export default __webpack_public_path__ + "static/media/component-4.240f3b08.png";